// this file handles the carousels found around the web page.

import Flickity from 'flickity'
// import 'flickity/dist/flickity.min.css'
import 'flickity-imagesloaded'

export function activateHomeStats () {
  console.log('Activating Home Stats 4')
  const homeSlider = document.querySelector('.region--school-stats')

  if (homeSlider) {
    setupFlickity(homeSlider)
  }
}

function setupFlickity (element) {
  const options = {
    cellAlign: 'center',
    // imagesLoaded: true,
    contain: true,
    autoPlay: 8000,
    wrapAround: true,
    prevNextButtons: true,
    pauseAutoPlayOnHover: false,
    cellSelector: '.region--school-stats .field--name-body',
    // adaptiveHeight: true
    pageDots: false
  }

  const instance = new Flickity(element, options)

  // console.log({ instance })
}
